import { atom } from "recoil";
import { localStorageEffect } from "./effects";

const DEFAULT_AUTH_ATOM_VALUE = {
  name: "",
  picture: "",
  access_token: "",
  refresh_token: "",
  id_token: "",
};

const authAtom = atom({
  key: "auth",
  default: DEFAULT_AUTH_ATOM_VALUE,
  // get initial state from local storage to enable user to stay logged in
  effects: [localStorageEffect("authAtom")],
});

const authApiClientAtom = atom({
  key: "authApiClient",
  default: null,
});

export { authAtom, authApiClientAtom, DEFAULT_AUTH_ATOM_VALUE };
